import { PricingGrid, formatMoney } from "./components";

function AddonCard({ addon, periodLabel }) {
  const { name, description, addonType, qty, pricePerSeat, price, total, originalTotal } = addon;

  const isSeats   = addonType === "seat";
  const isVehicle = addonType === "vehicle";

  const priceLabel = isSeats ? "Price/Seat" : isVehicle ? "Price/vehicle" : "Price";
  const priceRaw   = isSeats ? pricePerSeat : price;
  const priceValue = priceRaw != null
    ? isSeats ? `$${formatMoney(priceRaw)}${periodLabel}` : `$${formatMoney(priceRaw)}`
    : "—";

  const columns = [
    ...(isSeats ? [{ label: "Quantity", value: qty ?? "—" }] : []),
    { label: priceLabel, value: priceValue },
    {
      label: "Total",
      type: "total",
      value: total != null ? `$${formatMoney(total)}${periodLabel}` : "—",
      originalValue: originalTotal ? `$${formatMoney(originalTotal)}` : null,
    },
  ];

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <div className="mb-3">
        <h4 className="text-sm font-semibold text-gray-900">{name}</h4>
        {description && (
          <p className="text-xs text-gray-500 mt-0.5 leading-relaxed">
            {description}
          </p>
        )}
      </div>
      <PricingGrid columns={columns} />
    </div>
  );
}

function AddOn({ addons, periodLabel = "/mo" }) {
  return (
    <div className="px-5 pb-5">
      <div className="space-y-3">
        {addons.map((group) => (
          <div key={group.category}>
            <div className="mb-1.5">
              <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">
                {group.category}
              </span>
            </div>
            <div className="space-y-2">
              {group.items.map((addon) => (
                <AddonCard key={addon.name} addon={addon} periodLabel={periodLabel} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AddOn;
